import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {RequestService} from 'src/app/data/handlers/request/request.service';
import {globalEnv} from '../.././connection/global/global.env';
import {microCharges} from '../../api/micro-charges/micro-charges.api';

@Injectable({
  providedIn: 'root',
})
export class MicroChargesService {
  constructor(private req: RequestService) {}

  getValidAntifraud(data): Observable<any> {
    return this.req.get(`${globalEnv.be2}${microCharges.validAntifraud}`, data, null, true);
  }

  generateMicroCharge(params): Observable<any> {
    return this.req.post(`${globalEnv.be2}${microCharges.generateMicroCharge}`, params, null, true);
  }

  validateMicroCharge(params): Observable<any> {
    return this.req.post(`${globalEnv.be2}${microCharges.validateMicroCharge}`, params, null, true);
  }
}
